import { InstituteStoreTypes } from "store/type";

export const initGlobalState: InstituteStoreTypes = {
  instituteType: [],
  getInstituteTypeLoading: false,
  saveInstituteTypeLoading: false,
  updateInstituteTypeLoading: false,
  deleteInstituteTypeLoading: false,
};
